import { fetcher } from 'services/helpers/responseHandler'

const add = async ({ name, date, states, provinces }) =>
  fetcher.post('restrictedtextingdate/add-or-modify', {
    name,
    date,
    states,
    provinces
  })

const update = async ({ id, name, date, states, provinces }) =>
  fetcher.post('restrictedtextingdate/add-or-modify', {
    id,
    name,
    date,
    states,
    provinces
  })

const list = async ({ countryFilterKind = 'All', year }) =>
  fetcher.get('restrictedtextingdate/list', {
    countryFilterKind,
    year
  })

const getBetweenDates = async ({ startDate, endDate }) =>
  fetcher.get('restrictedtextingdate/all', {
    fromDate: startDate,
    toDate: endDate
  })

const restrictedDatesApi = {
  add,
  update,
  list,
  getBetweenDates
}

export default restrictedDatesApi
